
export const pricing = {
  'request.pricing': '価格を問い合わせる',
  'view.pricing': '価格を見る',
  'product.pricing': '製品価格',
};
